import { h } from 'preact';
import { useState, useEffect, useRef, useCallback } from 'preact/hooks';
import styles from './RangeSlider.module.scss';
export function RangeSlider({ min, max, gap, currentMin, currentMax, onChange, debounceMs = 400 }) {
    const [values, setValues] = useState({ min: currentMin, max: currentMax });
    const timerRef = useRef();
    useEffect(() => {
        setValues({ min: currentMin, max: currentMax });
    }, [currentMin, currentMax]);
    useEffect(() => () => { clearTimeout(timerRef.current); }, []);
    const debouncedOnChange = useCallback((newValues) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => onChange(newValues), debounceMs);
    }, [onChange, debounceMs]);
    const leftPct = ((values.min - min) / (max - min)) * 100;
    const rightPct = ((max - values.max) / (max - min)) * 100;
    const handleMinSlider = (e) => {
        const val = parseInt(e.target.value, 10);
        if (val < values.max - gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { min: val })));
            debouncedOnChange([val, values.max]);
        }
    };
    const handleMaxSlider = (e) => {
        const val = parseInt(e.target.value, 10);
        if (val > values.min + gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { max: val })));
            debouncedOnChange([values.min, val]);
        }
    };
    const handleMinText = (e) => {
        const val = parseInt(e.target.value, 10);
        if (!isNaN(val) && val >= min && val < values.max - gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { min: val })));
            debouncedOnChange([val, values.max]);
        }
    };
    const handleMaxText = (e) => {
        const val = parseInt(e.target.value, 10);
        if (!isNaN(val) && val <= max && val > values.min + gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { max: val })));
            debouncedOnChange([values.min, val]);
        }
    };
    return (h("div", { class: styles.rangeSlider },
        h("p", { class: styles.rangeLabel },
            "Price: ",
            min,
            " - $",
            max),
        h("div", { class: styles.textInputs },
            h("div", { class: styles.inputWrapper },
                h("span", { class: styles.dollar }, "$"),
                h("input", { type: "number", class: styles.textInput, value: values.min, min: min, max: values.max - gap, onChange: handleMinText })),
            h("div", { class: styles.inputWrapper },
                h("span", { class: styles.dollar }, "$"),
                h("input", { type: "number", class: styles.textInput, value: values.max, min: values.min + gap, max: max, onChange: handleMaxText }))),
        h("div", { class: styles.sliderWrapper },
            h("div", { class: styles.track },
                h("div", { class: styles.trackFill, style: `left: ${leftPct}%; right: ${rightPct}%` })),
            h("input", { type: "range", min: min, max: max, step: 1, value: values.min, onInput: handleMinSlider, class: `${styles.input} ${styles.inputMin}` }),
            h("input", { type: "range", min: min, max: max, step: 1, value: values.max, onInput: handleMaxSlider, class: `${styles.input} ${styles.inputMax}` }))));
}
